var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppAvatarGroup',{attrs:{"numToShow":_vm.numToShow,"userIds":_vm.idea.account_idea?.voters || []}})
}
var staticRenderFns = []

export { render, staticRenderFns }